import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import {
    deleteMAGAA010,
    getMAGAA020Code,
    getMAGAA020Name,
    postMAGAA010,
    postMAGAA020,
    putMAGAA020,
} from '../../../services/Api';
import Pagination from '../../../shared/components/Pagination';
import SideMenu from '../../../shared/components/SideMenu';

import { MENU_MANAGEMENT, MESSAGE } from '../../../shared/constants/app';
import { formatDate, formatNumberWithCommas, handleFocus } from '../../../utils';

const MAGAA010 = () => {
    const [data, setData] = useState([]);
    const [popupData, setPopupData] = useState([]);
    const [isPopupVisile, setIsPopupVisile] = useState(false);
    const [isEditing, setIsEditing] = useState(false);

    const [searchParams] = useSearchParams();
    const page = Number(searchParams.get('page')) || 1;
    const [pages, setPages] = useState({});
    const getListData = () => {
        postMAGAA010({ page })
            .then(({ data }) => {
                setData(data.data);
                setPages(data.info);
            })
            .catch((error) => {
                console.error(error);
            });
    };

    const handleDelete = async (seq) => {
        if (window.confirm(MESSAGE.confirm.delete)) {
            try {
                await deleteMAGAA010(seq);
                window.alert(MESSAGE.notify.deleteSuccess);
                getListData();
            } catch (error) {
                console.error(error);
                window.alert(MESSAGE.notify.deleteError);
            }
        }
    };

    const handleAdd = () => {
        setPopupData({ code: '', name: '', dspYN: 'Y', ord: '' });
        setIsEditing(false);
        setIsPopupVisile(true);
    };

    const handleOpen = (seq) => {
        setIsEditing(true);
        setIsPopupVisile(true);
        const itemData = data.find((item) => item.seq === seq);
        setPopupData(itemData);
    };

    const handleClose = () => {
        setIsPopupVisile(false);
        setPopupData(null);
    };

    const handleChangeInput = (e) => {
        const { name, value } = e.target;
        if (name === 'ord' && /^\d*$/.test(value)) {
            setPopupData((prev) => ({
                ...prev,
                [name]: value,
            }));
        } else {
            setPopupData((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
    };

    const handleBlur = async (fieldName, value) => {
        if (!value) return;
        if (isEditing) return;
        try {
            if (fieldName === 'code') {
                await getMAGAA020Code(value);
                window.alert('이미 사용된 코드입니다.');
            } else if (fieldName === 'name') {
                await getMAGAA020Name(value);
                window.alert('이미 사용된 업무명입니다.');
            }
        } catch (error) {
            console.error(error);
        }
    };

    const handleSave = async () => {
        if (!popupData.name) {
            window.alert('업무명을 입력해 주세요.');
            handleFocus('name');
            return;
        } else if (!popupData.ord) {
            window.alert('순위를 입력해 주세요.');
            handleFocus('ord');
            return;
        }

        try {
            const payload = {
                code: popupData.code,
                name: popupData.name,
                dspYN: popupData.dspYN,
                ord: popupData.ord,
            };
            console.log(payload);

            if (isEditing) {
                // update
                payload.seq = popupData.seq;
                await putMAGAA020(payload);
            } else {
                await postMAGAA020(payload);
            }

            window.alert(isEditing ? MESSAGE.notify.updateSuccess : MESSAGE.notify.createSuccess);

            getListData();
            handleClose();
        } catch (error) {
            console.error(error);
            window.alert('이미 사용된 코드, 업무명으로 변경할 수 없습니다.');
        }
    };

    useEffect(() => {
        getListData();

        // eslint-disable-next-line
    }, [page]);

    return (
        <div className="container">
            <div className="wrap">
                <SideMenu menu={MENU_MANAGEMENT} />

                <div className="dental-task-management-list content-right">
                    <div className="title title-list-notification">업무관리</div>
                    <div className="results">
                        <div className="group-top-item">
                            <div className="count-item">
                                총 <span className="total">{formatNumberWithCommas(pages?.totalRow || 0)}</span>건
                            </div>
                            <div className="button-item">
                                <Link onClick={handleAdd}>업무 추가</Link>
                            </div>
                        </div>
                        <table className="table-gray">
                            <thead>
                                <tr>
                                    <th>순위</th>
                                    <th>항목명</th>
                                    <th>공개여부</th>
                                    <th>등록일</th>
                                    <th>코드</th>
                                    <th>관리</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data && data.length > 0 ? (
                                    data.map((item) => (
                                        <tr key={item.seq}>
                                            <td>{item.ord}</td>
                                            <td>{item.name}</td>
                                            <td>{item.dspYN === 'Y' ? '공개' : '비공개'}</td>
                                            <td>{formatDate(item.addDate)}</td>
                                            <td>{item.code}</td>
                                            <td>
                                                <button className="edit" onClick={() => handleOpen(item.seq)}>
                                                    수정
                                                </button>
                                                <button className="delete" onClick={() => handleDelete(item.seq)}>
                                                    삭제
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={7}>데이타가 없습니다.</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        <Pagination pages={pages} />
                    </div>
                </div>
            </div>
            {isPopupVisile && (
                <div id="popup">
                    <div className="overlay" onClick={handleClose} />
                    <div className="popup-content" style={{ width: '500px' }}>
                        <div className="popup-close" onClick={handleClose} />
                        <div className="popup-title">업무관리 등록/수정</div>
                        <div className="popup-table">
                            <div className="table-row">
                                <div className="table-row-title" style={{ width: '30%' }}>
                                    코드
                                </div>
                                <div className="table-row-content">
                                    <input
                                        type="text"
                                        className="input-reason"
                                        name="code"
                                        value={popupData.code}
                                        onChange={handleChangeInput}
                                        onBlur={() => handleBlur('code', popupData.code)}
                                    />
                                </div>
                            </div>
                            <div className="table-row">
                                <div className="table-row-title" style={{ width: '30%' }}>
                                    업무명
                                </div>
                                <div className="table-row-content">
                                    <input
                                        type="text"
                                        className="input-reason"
                                        name="name"
                                        value={popupData.name}
                                        onChange={handleChangeInput}
                                        onBlur={() => handleBlur('name', popupData.name)}
                                    />
                                </div>
                            </div>
                            <div className="table-row">
                                <div className="table-row-title" style={{ width: '30%' }}>
                                    공개 여부
                                </div>
                                <div className="table-row-content">
                                    <select onChange={handleChangeInput} name="dspYN" value={popupData.dspYN}>
                                        <option value="Y">공개</option>
                                        <option value="N">비공개</option>
                                    </select>
                                </div>
                            </div>
                            <div className="table-row">
                                <div className="table-row-title" style={{ width: '30%' }}>
                                    순위
                                </div>
                                <div className="table-row-content">
                                    <input
                                        type="number"
                                        className="input-reason"
                                        name="ord"
                                        value={popupData.ord}
                                        onChange={handleChangeInput}
                                        min={1}
                                        max={100}
                                        onPaste={(e) => {
                                            const pastedText = e.clipboardData.getData('text');
                                            const numValue = Number(pastedText);
                                            if (isNaN(numValue) || numValue < 1 || numValue > 100) {
                                                e.preventDefault();
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <button className="popup-button" onClick={handleSave}>
                            저장
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default MAGAA010;
